import React, {useEffect, useRef} from 'react';
import {useDispatch} from 'react-redux';
import {
  deleteCommunityServiceEvent,
  cancelCommunityServiceEvent,
  scrolledToService,
} from 'shared/portfolio/actions/community-service';
import CommunityService from 'shared/components/form-inputs/community-service';
import PortfolioFormFooter from 'src/components/PortfolioFormFooter';
import FormCard from '../form-card';
import CommunityServiceFormWrapper, {
  CommunityService as CommunityServiceType,
} from './community-service-form-wrapper';

interface Props {
  communityService: CommunityServiceType;
}

const CommunityServiceFormCard = ({communityService}: Props) => {
  const ref = useRef<HTMLDivElement>(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (communityService.scrollTo) {
      setTimeout(() => {
        ref.current?.scrollIntoView({behavior: 'smooth'});
        dispatch(scrolledToService(communityService._id));
      }, 550);
    }
  }, [dispatch, communityService._id, communityService.scrollTo]);

  return (
    <FormCard ref={ref} id={communityService._id}>
      <CommunityServiceFormWrapper initialValues={communityService}>
        <h4 className="portfolio-sections add-edit-header">
          {communityService.new ? 'Add' : 'Edit'} Community Service
        </h4>
        <CommunityService />
        <PortfolioFormFooter
          _id={communityService._id}
          onCancel={() => dispatch(cancelCommunityServiceEvent(communityService))}
          onDelete={() => {
            dispatch(deleteCommunityServiceEvent(communityService._id));
          }}
          formName="portfolio community-service-events community-service-event-form"
        />
      </CommunityServiceFormWrapper>
    </FormCard>
  );
};

export default CommunityServiceFormCard;
